import React from "react"
import { TIconName, TIconPaths } from "./TIconPaths"

/**
 * 에디터 전용 SVG 아이콘 렌더러
 *
 * @description
 * 에디터 UI에서 사용하는 아이콘 컴포넌트입니다. TIcon과 유사하지만 TIconName(v1) 아이콘 세트를 사용합니다.
 * 일반 UI에서는 TIcon(v2)을 사용하세요.
 *
 * @example
 * ```tsx
 * <TEditorIcon name="bold" size={20} />
 * <TEditorIcon name="italic" size={20} color="text-secondary" />
 * ```
 */
interface TEditorIconProps {
	/** 추가 CSS 클래스 */
	className?: string
	/** 에디터 아이콘 이름 (TIconName v1 타입) */
	name: TIconName
	/**
	 * 아이콘 크기 (px)
	 * @default 24
	 * @ai-style 16 → 소형 인라인 아이콘
	 * @ai-style 20 → 에디터 툴바 기본 크기
	 * @ai-style 24 → 기본 크기
	 */
	size?: number
	/** CSS 커스텀 프로퍼티명 (예: "text", "text-secondary") — var(--{color})로 적용 */
	color?: string
	/** 그림자 효과 */
	shadow?: boolean
}

export const TEditorIcon = React.memo((props: TEditorIconProps) => {
	const { className, name, size = 24, color, shadow } = props

	return (
		<svg
			suppressHydrationWarning
			className={className}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill={color ? `var(--${color})` : "var(--text)"}
			fillRule="evenodd"
			clipRule="evenodd"
			aria-hidden="true"
			style={{
				filter: shadow ? "drop-shadow( 0px 0px 2px rgba(0, 0, 0, 0.25))" : undefined
			}}
		>
			<path d={TIconPaths[name]} />
		</svg>
	)
})

TEditorIcon.displayName = "TEditorIcon"
